const GET_ACCOUNTS_REQUESTED = "GET_ACCOUNTS_REQUESTED";
const GET_ACCOUNTS_SUCCEEDED = "GET_ACCOUNTS_SUCCEEDED";
const GET_ACCOUNTS_FAILED = "GET_ACCOUNTS_FAILED";

export {
  GET_ACCOUNTS_REQUESTED,
  GET_ACCOUNTS_SUCCEEDED,
  GET_ACCOUNTS_FAILED,
}
